import {
  db_value_1_data_no_year_summary,
  dimensiondata_1_regiok_es_varmegyek_group_dimension_1_2_row,
  dimensiondata_2_tetelek_group_dimension_1_2_3_first_column_expanded,
  kilowatt_value_2_data_no_year_summary,
  quarter_row_expanded,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const elektromobilitasTorzsConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/ElektromobilitasTorzs',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      quarter_row_expanded,
      ...dimensiondata_1_regiok_es_varmegyek_group_dimension_1_2_row,
      ...dimensiondata_2_tetelek_group_dimension_1_2_3_first_column_expanded,
      db_value_1_data_no_year_summary,
      kilowatt_value_2_data_no_year_summary,
      order_1,
      order_2
    ],
  },
};
